export class TypeOfSchool {
    id : number;
    typeOfSchoolName : string;
}